<template>
  <div>
    <base-modal hide-footer @close="$emit('close')">
      <div class="editor-form form-data" @click.stop="">
          <!-- Tabs Navigation -->
          <ul class="nav nav-tabs routa-tabs">
              <li class="nav-item">
                  <button class="routa-tab" :class="{ active: tabIndex === 0 }" @click="tabIndex = 0">
                      {{ $t('trip_list.search_with_road_name') }}
                  </button>
              </li>
              <li class="nav-item">
                  <button class="routa-tab" :class="{ active: tabIndex === 1 }" @click="tabIndex = 1">
                      {{ $t('map.street_address') }}
                  </button>
              </li>
          </ul>

          <!-- Tab Content -->
          <div class="tab-content routa-tab-content">
              <div class="tab-pane fade" :class="{ show: tabIndex === 0, active: tabIndex === 0 }">
                  <span class="span-title"> {{ $t('map.road_name') }} </span>
                  <input
                      id="road-name"
                      v-model="roadName"
                      type="text"
                      class="form-control form-control-sm pb-2"
                      :class="roadName ? 'is-valid' : 'is-invalid'"
                      @keydown.enter.prevent="searchRoad"
                  />

                  <span class="span-title"> {{ $t('map.city') }} </span>
                  <input
                      id="city-name"
                      v-model="city"
                      type="text"
                      class="form-control form-control-sm pb-2"
                      :class="city ? 'is-valid' : 'is-invalid'"
                      @keydown.enter.prevent="searchRoad"
                  />

                  <hr class="ml-2 mr-2 mb-0 report-divider">

                  <span class="span-title pt-0"> {{ $t('map.road_number') }} </span>
                  <input
                      id="road-number"
                      v-model="roadNumber"
                      type="number"
                      min="0"
                      step="1"
                      class="form-control form-control-sm pb-2"
                      @keydown.enter.prevent="searchRoad"
                  />
              </div>

              <div class="tab-pane fade" :class="{ show: tabIndex === 1, active: tabIndex === 1 }">

                  <!-- Select väylävirasto or routa to search by street adress -->
                  <div class="pb-2">
                      <span class="span-title pt-0"> {{ $t('map.road_number') }} </span>
                      <input
                          id="road-number"
                          v-model="roadNumber"
                          type="number"
                          min="0"
                          step="1"
                          class="form-control form-control-sm"
                          :class="roadNumber ? 'is-valid' : 'is-invalid'"
                          @keydown.enter.prevent="searchRoad"
                      />
                  </div>

                  <div class="row nopads">
                      <div class="col nopads mr-2">
                          <span class="span-title"> {{ $t('map.road_section_start') }} </span>
                      </div>
                      <div class="col nopads ml-2">
                          <span class="span-title"> {{ $t('map.distance_start') }} </span>
                      </div>
                  </div>
                  <div class="row nopads">
                      <div class="col nopads mr-2 pb-2">
                          <input
                              id="road-section-from"
                              v-model="roadSectionFrom"
                              type="number"
                              min="0"
                              step="1"
                              class="form-control form-control-sm"
                              :class="roadSectionFrom ? 'is-valid' : 'is-invalid'"
                              @keydown.enter.prevent="searchRoad"
                          />
                      </div>
                      <div class="col nopads ml-2 pb-2">
                          <input
                              id="distance-from"
                              v-model="distanceFrom"
                              type="number"
                              min="0"
                              step="1"
                              class="form-control form-control-sm"
                              @keydown.enter.prevent="searchRoad"
                          />
                      </div>
                  </div>
                  <div class="row nopads">
                      <div class="col nopads mr-2">
                          <span class="span-title"> {{ $t('map.road_section_end') }} </span>
                      </div>
                      <div class="col nopads ml-2">
                          <span class="span-title"> {{ $t('map.distance_end') }} </span>
                      </div>
                  </div>
                  <div class="row nopads">
                      <div class="col nopads mr-2 pb-2">
                          <input
                              id="road-section-to"
                              v-model="roadSectionTo"
                              type="number"
                              min="0"
                              step="1"
                              class="form-control form-control-sm"
                              @keydown.enter.prevent="searchRoad"
                          />
                      </div>
                      <div class="col nopads ml-2 pb-2">
                          <input
                              id="distance-to"
                              v-model="distanceTo"
                              type="number"
                              min="0"
                              step="1"
                              class="form-control form-control-sm"
                              @keydown.enter.prevent="searchRoad"
                          />
                      </div>
                  </div>


              </div>

          </div>

        <div class="button-container">
          <button class="btn btn-primary btn-sm form-button" :disabled="!isSearchable && !loading" @click.stop="searchRoad">
            {{ $t('common.search') }}
          </button>
        </div>

        <ul
          v-if="suggestion && suggestion.features"
          class="suggestions-list"
        >
          <li @click="drawOnMap(suggestion)">
            {{ getSuggestionLabel(suggestion) }}
          </li>
        </ul>
        <span v-else-if="searchDone">{{ $t('area_report.no_results') }}</span>
      </div>
      <div
        v-if="loading"
        id="loader"
        class="spinner"
      />
    </base-modal>
  </div>
</template>

<script>
import BaseModal from '../BaseModal'
import {restApi} from "@/components/mixins/RestApiMixin";
import {inject} from "vue";

export default {
    name: 'RoadSearchWizard',
    components: { BaseModal },
    mixins: [restApi],
    props: {
        coordinates: {
            type: Object,
            default() {
                return null
            },
        },
        map: {
            type: Object,
            default: null,
        },
    },
    setup() {
        // Inject parents alerter
        const showAlert = inject('showAlert');
        return { showAlert };
    },
    data() {
        return {
            loading: false,
            roadName: '',
            roadNumber: null,
            roadSectionFrom: null,
            roadSectionTo: null,
            distanceFrom: null,
            distanceTo: null,
            city: '',
            suggestion: null,
            searchDone: false,
            tabIndex: 0
        }
    },

    computed: {
        isSearchable() {
            if (this.tabIndex === 0) {
                return (!!this.roadName && !!this.city );
            } else {
                return (!!this.roadNumber  && !!this.roadSectionFrom)
            }
        }
    },

    watch: {
        tabIndex() {
            this.resetForm()
        }
    },

    methods: {
        searchRoad() {
            this.suggestion = null
            if (this.tabIndex === 1) {
                // Search for road section
                this.loading = true
                this.restFetchParams(this.roadSectionUrl, {
                    road: this.roadNumber,
                    fromSection: this.roadSectionFrom,
                    fromDistance: this.distanceFrom,
                    toSection: this.roadSectionTo,
                    toDistance: this.distanceTo,
                    useVaylavirasto: true
                }, this.handleResponse, this.onError)
            } else {
                // Search with name and city
                this.loading = true
                this.restFetchParams(this.roadGeometryUrl, {
                    roadName: this.roadName,
                    city: this.city,
                    roadNum: this.roadNumber,
                    secNum: this.roadSectionFrom,
                    geoJson: 1
                }, this.handleResponse, this.onError)
            }
        },
        handleResponse(response) {
            this.loading = false
            if (response && response.data) {
                this.suggestion = response.data
                this.searchDone = true
            }
        },
        onError() {
            this.loading = false
            this.showAlert(this.$t('common.alert_update_failed'))
        },
        drawOnMap(geoJson) {
            if (geoJson) {
                this.$emit('roadSelected', JSON.stringify(geoJson))
            }
        },
        resetForm() {
            this.roadName = ''
            this.roadNumber = null
            this.roadSectionFrom = null
            this.roadSectionTo = null
            this.distanceFrom = null
            this.distanceTo = null
            this.city = ''
            this.searchDone = false
            this.suggestion = null
        },
        getSuggestionLabel(suggestion) {
            if (suggestion.features && suggestion.features.length > 0) {
                let result = ''
                if (suggestion.features[0].properties.roadNumber) {
                    result += suggestion.features[0].properties.roadNumber
                    if (this.roadSectionFrom) {
                        result += "/ " + this.roadSectionFrom
                    }
                    if (this.roadSectionTo) {
                        result += " - " + this.roadSectionTo
                    }
                }
                if (suggestion.features[0].properties.roadName) {
                    result = result.length > 0 ? result + " " : ""
                    result += suggestion.features[0].properties.roadName
                }
                if (suggestion.features[0].properties.city) {
                    result = result.length > 0 ? result + ", " : ""
                    result += suggestion.features[0].properties.city
                }
                return result
            }
            return this.$t('area_report.no_results')
        },

        linkTabClass(index) {
            if (this.tabIndex === index) {
                return ['tab-title', 'tab-title-active']
            } else {
                return ['tab-title']
            }
        },
    }
}
</script>
<style lang="scss" scoped>
@import '../../styles/modal.css';
.road-search-wizard {
    z-index: 1000;
}
ul.suggestions-list {
    list-style: none;
    padding: 0;
    margin: 1rem 0 0 0;
    max-height: 400px;
    overflow: auto;

    li {
        padding: 1em 0.5em;
        border-bottom: 1px solid rgba(0, 0, 0, 0.1);
        Transition: background-color 0.25s ease-out;
        cursor: pointer;

        &:last-child {
            border-bottom: none;
        }
        &:only-child {
            border-top: 1px solid rgba(0, 0, 0, 0.1);
            border-bottom: 1px solid rgba(0, 0, 0, 0.1);
        }
        &:hover {
            background-color: rgba(0, 0, 0, 0.1);
        }
    }
}
</style>
